<div class="gear-container">
	<style type="text/css">
		.st0 {
			fill: var(--svg-gear-bg-1);
		}
		.st1 {
			fill: var(--svg-gear-bg-2);
		}
		.st2 {
			fill: var(--svg-gear-bg-3);
		}
		.st3 {
			fill: none;
			stroke: var(--primary-color-2);
			stroke-width: 0.7681;
			stroke-miterlimit: 10;
			stroke-dasharray: 4.6084, 4.6084;
		}
		.st4 {
			fill: var(--primary-color-1);
		} /*first outside*/
		.st5 {
			fill: url(#Caminho_6_1_);
		}
		.st6 {
			fill: var(--primary-color-2);
		} /*second outside*/
		.st7 {
			fill: url(#Caminho_8_1_);
		}
		.st8 {
			fill: var(--svg-gear-bg-4);
		}
	</style>

	<svg
		version="1.1"
		class="background"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		viewBox="0 0 500 500"
		style="enable-background: new 0 0 500 500"
		xml:space="preserve">
		<path
			id="Caminho_1"
			class="st0"
			d="M416.6,379.8c-28.8,55.5-240.7,85-311.4,50.4c-68.1-33.3-56-403.8,117.2-390.8
            C351.5,49.1,480.5,256.6,416.6,379.8z" />
		<path
			id="Caminho_2"
			class="st1"
			d="M58.1,390.3c10-5.2-2.1-63.3-18.2-70c-16.1-6.7-33.5,26.5-27.2,45.3
            C19,384.3,40.8,399.4,58.1,390.3z" />
		<path
			id="Caminho_3"
			class="st2"
			d="M444.9,198.3c-9.1,5.8,6.3,57.1,21.3,60.8c15.1,3.7,25-25.9,19-40.5
            C479.3,204,458,189.9,444.9,198.3z" />
		<path
			id="Caminho_4"
			class="st3"
			d="M93.6,375.9c-25.8-19.3-42.3-63.5-12.6-98.5c29.5-34.7,73.3-44.6,98.3-99.4
            c3.1-6.9,5.6-14.2,4.4-21.7c-1.5-9.9-12-17.4-17.3-9.8c-5.9,8.4,3.6,25.5,25.4,34c24.5,9.4,51.4,10.4,76.4,2.7
            c25.5-7.9,48-24.5,74-30.6c41.7-9.7,88.9,12.3,109.9,51.1c13,24.1,15.3,53.3,8,79.4" />
		<path
			id="Caminho_9"
			class="st8"
			d="M23,337.5c-6.5-3.4,1.4-41.2,11.8-45.5c10.4-4.3,21.7,17.2,17.7,29.4
            C48.4,333.6,34.2,343.4,23,337.5z" />
		<path
			id="Caminho_10"
			class="st8"
			d="M442.5,211.6c-6.4,4.1,4.4,40.3,15.1,43c10.7,2.6,17.6-18.3,13.5-28.6
            C466.9,215.6,451.8,205.7,442.5,211.6z" />
	</svg>

	<svg
		version="1.1"
		class="left-gear"
		[ngStyle]="{ 'animation-duration': gearSpinDurationMS + 'ms' }"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		viewBox="0 0 500 500"
		style="enable-background: new 0 0 500 500"
		xml:space="preserve">
		<g>
			<path
				id="Caminho_5"
				class="st4"
				d="M110.4,419.3l18.2,7.5c4.1,1.7,8.8,0.6,11.8-2.7c1.8-2,3.8-3.9,5.7-5.8c3.3-3,4.3-7.7,2.7-11.8
                l-7.6-18.2c-2.2-5.4,0.3-11.5,5.7-13.8l41.4-17.2c5.4-2.2,11.5,0.3,13.8,5.7l7.6,18.2c1.7,4.1,5.8,6.7,10.3,6.5
                c2.7-0.1,5.4-0.1,8.1,0c4.4,0.2,8.5-2.4,10.2-6.5l7.5-18.2c2.2-5.4,8.4-7.9,13.7-5.7l41.4,17.1c5.4,2.2,7.9,8.4,5.7,13.8l-7.5,18.2
                c-1.7,4.1-0.6,8.8,2.7,11.8c2,1.9,3.9,3.8,5.8,5.7c3,3.3,7.7,4.3,11.8,2.7l18.2-7.5c5.4-2.2,11.5,0.3,13.8,5.7l0,0l17.2,41.4
                c2.2,5.4-0.3,11.5-5.7,13.8l-18.2,7.6c-4.1,1.7-6.7,5.8-6.5,10.3c0.1,2.7,0.1,5.4,0,8.1c-0.2,4.4,2.4,8.5,6.5,10.3l18.2,7.5
                c5.4,2.2,7.9,8.4,5.7,13.7l-17.1,41.4c-2.2,5.4-8.4,7.9-13.8,5.7l-18.2-7.5c-4.1-1.7-8.8-0.6-11.8,2.7c-1.8,2-3.8,3.9-5.7,5.8
                c-3.3,3-4.3,7.7-2.7,11.8l7.6,18.2c2.2,5.4-0.3,11.5-5.7,13.8l0,0l-41.4,17.2c-5.4,2.2-11.5-0.3-13.8-5.7l-7.6-18.2
                c-1.7-4.1-5.8-6.7-10.3-6.5c-2.7,0.1-5.4,0.1-8.1,0c-4.4-0.2-8.5,2.4-10.2,6.5l-7.5,18.2c-2.2,5.4-8.4,7.9-13.7,5.7l-41.4-17.1
                c-5.4-2.2-7.9-8.4-5.7-13.8l7.5-18.2c1.7-4.1,0.6-8.8-2.7-11.8c-2-1.9-3.9-3.8-5.8-5.7c-3-3.3-7.7-4.3-11.8-2.7l-18.2,7.6
                c-5.4,2.2-11.5-0.3-13.8-5.7l0,0l-17.2-41.4c-2.2-5.4,0.3-11.5,5.7-13.8l18.2-7.6c4.1-1.7,6.7-5.8,6.5-10.3c-0.1-2.7-0.1-5.4,0-8.1
                c0.2-4.4-2.4-8.5-6.5-10.3l-18.2-7.5c-5.4-2.2-7.9-8.4-5.7-13.8L96.6,425C98.8,419.7,105,417.1,110.4,419.3
                C110.3,419.3,110.3,419.3,110.4,419.3z M206.6,544.2c23.4,9.6,50.1-1.5,59.8-24.9s-1.5-50.1-24.9-59.8
                c-23.4-9.6-50.1,1.5-59.8,24.9C172.1,507.8,183.3,534.6,206.6,544.2L206.6,544.2L206.6,544.2z" />

			<linearGradient
				id="Caminho_6_1_"
				gradientUnits="userSpaceOnUse"
				x1="50.876"
				y1="-47.7995"
				x2="50.876"
				y2="-49.4034"
				gradientTransform="matrix(-136.8919 0 0 136.8916 7188.6211 7159.6045)">
				<stop offset="0" style="stop-color: light-dark(var(--primary-color-1-hover), var(--primary-color-1-hover))" />
				<stop offset="1" style="stop-color: light-dark(var(--primary-color-1-hover), var(--primary-color-1-hover))" />
			</linearGradient>
			<path
				id="Caminho_6"
				class="st5"
				d="M264.2,404.7c53.7,22.1,79.2,83.6,57.1,137.3c-22.1,53.7-83.6,79.2-137.3,57.1
                c-53.7-22.1-79.2-83.6-57.1-137.3l0,0C149.1,408.1,210.5,382.6,264.2,404.7z M201.4,556.8c30.3,12.5,65.1-1.9,77.6-32.3
                c12.5-30.3-1.9-65.1-32.3-77.6c-30.3-12.5-65.1,1.9-77.6,32.3l0,0C156.7,509.5,171.1,544.3,201.4,556.8L201.4,556.8z" />
		</g>
	</svg>

	<svg
		version="1.1"
		class="right-gear"
		[ngStyle]="{ 'animation-duration': gearSpinDurationMS + 'ms' }"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		viewBox="0 0 500 500"
		style="enable-background: new 0 0 500 500"
		xml:space="preserve">
		<g>
			<path
				id="Caminho_7"
				class="st6"
				d="M303.5,318.2l12.2,0.3c2.7,0.1,5.3-1.6,6.3-4.2c0.6-1.6,1.3-3.1,2-4.6c1.2-2.5,0.8-5.4-1.1-7.4
                l-8.4-8.8c-2.5-2.6-2.4-6.7,0.2-9.2l20.1-19.1c2.6-2.5,6.7-2.4,9.2,0.2l8.4,8.8c1.9,2,4.9,2.6,7.4,1.5c1.5-0.7,3.1-1.3,4.7-1.8
                c2.6-0.9,4.4-3.3,4.5-6l0.3-12.2c0.1-3.6,3.1-6.5,6.7-6.4l27.7,0.7c3.6,0.1,6.5,3.1,6.4,6.7l0,0l-0.3,12.2
                c-0.1,2.7,1.6,5.3,4.2,6.3c1.6,0.6,3.1,1.3,4.6,2c2.5,1.2,5.4,0.8,7.4-1.1l8.8-8.4c2.6-2.5,6.7-2.4,9.2,0.2l19.1,20.1
                c2.5,2.6,2.4,6.7-0.2,9.2l-8.8,8.4c-2,1.9-2.6,4.9-1.5,7.4c0.7,1.5,1.3,3.1,1.8,4.7c0.9,2.6,3.3,4.4,6,4.5l12.2,0.3
                c3.6,0.1,6.5,3.1,6.4,6.7l0,0l-0.7,27.7c-0.1,3.6-3.1,6.5-6.7,6.4l-12.2-0.3c-2.7-0.1-5.3,1.6-6.3,4.2c-0.6,1.6-1.3,3.1-2,4.6
                c-1.2,2.5-0.8,5.4,1.1,7.4l8.4,8.8c2.5,2.6,2.4,6.7-0.2,9.2l-20.1,19.1c-2.6,2.5-6.7,2.4-9.2-0.2l-8.4-8.8c-1.9-2-4.9-2.6-7.4-1.5
                c-1.5,0.7-3.1,1.3-4.7,1.8c-2.6,0.9-4.4,3.3-4.5,6l-0.3,12.2c-0.1,3.6-3.1,6.5-6.7,6.4l0,0l-27.7-0.7c-3.6-0.1-6.5-3.1-6.4-6.7l0,0
                l0.3-12.2c0.1-2.7-1.6-5.3-4.2-6.3c-1.6-0.6-3.1-1.3-4.6-2c-2.5-1.2-5.4-0.8-7.4,1.1l-8.8,8.4c-2.6,2.5-6.7,2.4-9.2-0.2l-19.1-20.1
                c-2.5-2.6-2.4-6.7,0.2-9.2l8.8-8.4c2-1.9,2.6-4.9,1.5-7.4c-0.7-1.5-1.3-3.1-1.8-4.7c-0.9-2.6-3.3-4.4-6-4.5l-12.2-0.3
                c-3.6-0.1-6.5-3.1-6.4-6.7l0,0l0.7-27.7C296.9,320.9,299.9,318.1,303.5,318.2z M386.8,369.1c15.7,0.4,28.7-12,29.1-27.6
                c0.4-15.7-12-28.7-27.6-29.1c-15.7-0.4-28.7,12-29.1,27.6C358.8,355.7,371.1,368.7,386.8,369.1z" />

			<linearGradient
				id="Caminho_8_1_"
				gradientUnits="userSpaceOnUse"
				x1="51.0772"
				y1="-47.2667"
				x2="51.0265"
				y2="-48.9181"
				gradientTransform="matrix(-84.7366 0 0 84.7365 4713.3003 4420.9253)">
				<stop offset="0" style="stop-color: light-dark(var(--primary-color-2-hover), var(--primary-color-2-hover))" />
				<stop offset="1" style="stop-color: light-dark(var(--primary-color-2-hover), var(--primary-color-2-hover))" />
			</linearGradient>
			<path
				id="Caminho_8"
				class="st7"
				d="M389.2,275.7c35.9,0.9,64.3,30.8,63.4,66.7c-0.9,35.9-30.8,64.3-66.7,63.4
                c-35.9-0.9-64.3-30.8-63.4-66.7C323.4,303.1,353.2,274.8,389.2,275.7z M386.5,377.5c20.3,0.5,37.2-15.5,37.7-35.8
                s-15.5-37.2-35.8-37.7c-20.3-0.5-37.2,15.5-37.7,35.8S366.2,377,386.5,377.5L386.5,377.5z" />
		</g>
	</svg>
</div>
